import { Badge } from '@/components/ui/badge';
import type { HomeTaskSubscription } from '@rock/types';
import type { FC } from 'react';

const VARIANTS: Record<HomeTaskSubscription['status'], 'default' | 'secondary' | 'destructive' | 'outline'> = {
    active: 'default',
    paused: 'secondary',
    orphaned: 'destructive',
    deleted: 'outline',
};

/** Status badge for a HomeTaskSubscription (a "reminder"): active / paused / orphaned / deleted. */
export const ReminderStatusBadge: FC<{ status: HomeTaskSubscription['status'] }> = ({ status }) => (
    <Badge variant={VARIANTS[status]}>{status}</Badge>
);
